module.exports = __webpack_public_path__ + "img/iqvia-logo.45e584fa.svg";